import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import en from "./locales/en.json";

// FUNDIO CONTROL i18n standard. Static locale dictionaries only — no runtime/LLM
// translation. DE is the standard + fallback. Language priority is resolved at the
// application layer: User.preferred_language -> localStorage -> DE. An optional
// Organization.preferred_language hook can be layered in later (Customer App:
// User -> Organization -> DE) without changing this engine.
export const SUPPORTED_LANGS = ["de", "fr", "it", "en"];
export const FALLBACK_LANG = "de";
const STORAGE_KEY = "fundio_lang";

function initialLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  } catch {
    /* localStorage unavailable */
  }
  return FALLBACK_LANG;
}

export function persistLang(lng) {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    /* ignore */
  }
}

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    fr: { translation: fr },
    it: { translation: it },
    en: { translation: en },
  },
  lng: initialLang(),
  fallbackLng: FALLBACK_LANG,
  supportedLngs: SUPPORTED_LANGS,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
